module.exports = __webpack_public_path__ + "static/media/Instagram.58d0e1a9.svg";